var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"run-dates text-truncate",class:_vm.classes},[_vm._v("\n    "+_vm._s(_vm.runDates)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }